import type { AppEditPattern } from "@shared/models/analytics/app"
import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import Patch from "@shared/models/patch-updater"
import type { PreparedAction } from "@shared/actions/action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "@shared/actions/create-narrative"

interface Payload {
  userId: string
  originalHomescreenPattern: string | null
  homescreenPattern: string | null
}

export default function userChangeHomescreenPatternAction(payload: Payload): PreparedAction {
  return {
    name: "USER_CHANGE_DASHBOARD_PATTERN",
    payload: payload,
    patches: patches(payload),
    undoPatches: undoPatches(payload),
    narrative: partial(narrative, payload),
  }
}
function patches(payload: Payload) {
  let patch = Patch.create("user", payload.userId).set(
    "attributes.homescreenPattern",
    payload.homescreenPattern
  )

  return [patch.patch]
}

function undoPatches(payload: Payload) {
  let patch = Patch.create("user", payload.userId).set(
    "attributes.homescreenPattern",
    payload.originalHomescreenPattern
  )

  return [patch.patch]
}

function narrative(payload: Payload, findFn: FindFn, userId: string): Narrative {
  let newEvent: AppEditPattern = {
    ...createBlankEvent(),
    root_id: null,
    root_type: "app",
    date_plan_scheduled_for: null,

    primary_verb: "edit",
    primary_possessive: "owns",

    primary_object_type: "app",
    primary_object_id: "commoncurriculum.com",
    primary_object_specifier: "dashboard",
    primary_object_id_and_ancestor_ids: [payload.userId],
  }

  return {
    title: "Changed User Dashboard Pattern",
    titleForAnalytics: "User Dashboard Pattern - Change",
    description: `Changed your dashboard pattern to ${payload.homescreenPattern}`,
    context: { userId: payload.userId },
    activity: {
      actor: `user-${userId}`,
      verb: "edited",
      object: `app`,
      to: [`app-edits:user-${userId}`],
    },
    newAnalyticsEvents: [newEvent],
  }
}
